<template>
  <Popover v-if="initialMetadata?.models?.message_texts" v-slot="{ open }">
    <Float auto-placement portal :offset="10">
      <PopoverButton
        :class="open ? '' : 'text-opacity-90'"
        class="rounded border border-gray-300 px-2 py-1 leading-none"
      >
        <FontAwesomeIcon :icon="['far', 'feather']" />
      </PopoverButton>
      <PopoverPanel
        v-slot="{ close }"
        class="w-screen max-w-sm transform px-4 sm:max-w-xl sm:px-0"
      >
        <div
          class="flex max-h-64 min-h-42 flex-col gap-1 overflow-y-auto rounded-md border bg-white p-2 shadow-2xl"
        >
          <template
            v-if="initialMetadata.models?.message_texts?.formatted?.length"
          >
            <button
              v-for="message_text in initialMetadata.models.message_texts
                .formatted"
              :key="message_text.id"
              class="hover:bg-primary-500 shrink-0 truncate rounded bg-gray-50 px-2 py-1 text-left hover:text-white"
              @click="getSelectedOptions(message_text.id, close)"
            >
              {{ message_text.name }}
            </button>
          </template>
          <div
            v-else
            class="flex h-36 flex-row items-center justify-center font-bold"
          >
            {{ $t('global.is_empty_list') }}
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'

export default {
  name: 'MessageTextsPopover',
  components: { Float, Popover, PopoverPanel, FontAwesomeIcon, PopoverButton },
  props: {
    modelType: {
      type: String,
      required: false,
      default: null
    },
    modelId: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update-message'],
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    cModelType() {
      if(this.$route.name === 'dossier_form_document_preview_route') {
        return 'dossier'
      }
      return this.modelType ?? null
    },
    cModelId() {
      if(this.$route.name === 'dossier_form_document_preview_route') {
        return this.$route.params.id
      }
      return this.modelId ?? null
    }
  },
  methods: {
    ...mapActions({
      processFetchMessageTextConvertedAction:
        'messageText/fetchMessageTextConverted'
    }),
    getSelectedOptions(value, close) {
      this.processFetchMessageTextConvertedAction({
        model_type: this.cModelType,
        model_id: this.cModelId,
        message_text_id: value
      }).then((response) => {
        this.$emit('update-message', response)
      })
      close()
    }
  }
}
</script>

<style>
div[data-signature='true'] {
  margin-top: 5px;
  opacity: 0.85;
  background-color: #f9f9f9;
  padding: 5px;
  border-radius: 5px;
}
</style>
